<template>
    <div :class="{ 'status-tag': true, [lead.status ?? lead.status] : true }">{{ lead.status ?? lead.status | ucwords }}</div>
</template>

<script>

import Filters from '../../filters'

export default {
    props: {
        lead: {
            type: Object,
            required: true
        }
    },
    filters: Filters,
}
</script>

<style lang="scss" scoped>
    .status-tag {
        text-transform: uppercase;
        display: inline-block;
        padding: 2px .5rem;
        border-radius: 3px;
        font-weight: bold;
        font-size: 12px;
        background-color: #228b2229;
        color: forestgreen;

        &.lost { background-color: #ed143d1a; color: crimson; }
        &.closing, &.won { background-color: forestgreen; color: white; }
    }
</style>